window.addEventListener('DOMContentLoaded', () => {

    const articleImages = document.querySelectorAll('.article-template__content.rte img');

    if(!articleImages){
        return
    }

});